import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) { console.error("ErrorBoundary:", error, info); }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20, background: "#fff4f4", borderRadius: 8 }}>
          <h3 style={{ marginTop: 0, color: "#b71c1c" }}>Something went wrong</h3>
          <pre style={{ whiteSpace: "pre-wrap" }}>{String(this.state.error)}</pre>
          <p className="small">Open console for stack trace.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
